var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"overflow-y-scroll"},[_c('auth'),_c('div',{staticClass:"mx-auto w-full md:max-w-md mt-8"},[_c('local-memes',{staticClass:"w-full"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }